import { render, staticRenderFns } from "./PositionsManager.vue?vue&type=template&id=8ef62718&"
import script from "./PositionsManager.vue?vue&type=script&lang=ts&"
export * from "./PositionsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports